export const CALL_DISPOSITIONS = [
  { value: 'no_answer', label: 'No Answer' },
  { value: 'closed', label: 'Completed' },
  { value: 'voicemail', label: 'Voicemail' },
  { value: 'busy', label: 'Busy' },
  { value: 'wrong_number', label: 'Wrong Number' },
  { value: 'canceled', label: 'Canceled' },
  { value: 'failed', label: 'Failed' },
];
